/**
 * Client-side comms-only flag (baked at build via REACT_APP_COMMS_ONLY).
 */
export const isCommsOnly = () =>
  process.env.REACT_APP_COMMS_ONLY === 'true' ||
  process.env.REACT_APP_COMMS_ONLY === '1';

export default isCommsOnly;
